module.exports = __webpack_public_path__ + "img/No-Image.067d729a.svg";